module.exports = __webpack_public_path__ + "img/vodafone-logo.453cfd71.svg";